// extracted by mini-css-extract-plugin
export default {"header":"Header_header__6BWbV","main-image":"Header_main-image__m54ev"};